@if (showModal()) {
<app-modal (closeModal)="close()">
  <h1 modal-title>{{ buttonText }} Rollo</h1>

  <form
    [formGroup]="rollForm"
    (submit)="submit()"
    class="flex flex-col gap-4"
    modal-content
  >
    <div class="flex flex-col gap-2">
      <label for="roll-product">Producto</label>
      <ng-select
        id="roll-product"
        [items]="products"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        [searchable]="true"
        [clearable]="false"
        [closeOnSelect]="true"
        formControlName="product_id"
      ></ng-select>
    </div>

    <div class="flex flex-col gap-2">
      <label for="roll-supplier">Proveedor</label>
      <ng-select
        id="roll-supplier"
        [items]="suppliers"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        [searchable]="true"
        [clearable]="false"
        [closeOnSelect]="true"
        formControlName="supplier_id"
      ></ng-select>
    </div>

    <div class="flex flex-col gap-2">
      <label for="roll-warehouse">Almacén</label>
      <ng-select
        id="roll-warehouse"
        [items]="warehouses"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        [searchable]="true"
        [clearable]="false"
        [closeOnSelect]="true"
        formControlName="warehouse_id"
      ></ng-select>
    </div>

    <div class="flex flex-col gap-2">
      <label for="roll-identifier">Identificador</label>
      <input
        type="text"
        id="roll-identifier"
        formControlName="roll_identifier"
        class="basic-input"
      />
      <!-- (click)="generateRollIdentifier()" -->
    </div>

    <div class="flex flex-col gap-2">
      <label for="roll-color">Color</label>
      <ng-select
        id="roll-color"
        [items]="colors"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        [searchable]="false"
        [clearable]="false"
        [closeOnSelect]="true"
        formControlName="color"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="flex items-center">
            <app-color-total [color]="item.id" class="mr-2"></app-color-total>
            {{ item.name }}
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div class="flex items-center">
            <app-color-total [color]="item.id" class="mr-2"></app-color-total>
            {{ item.name }}
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="flex flex-row gap-x-2">
      <div class="flex flex-col gap-2">
        <label for="roll-initial-length">Rinde</label>
        <input
          type="number"
          id="roll-initial-length"
          formControlName="initial_length_meters"
          class="basic-input"
        />
      </div>

      <div class="flex flex-col gap-2">
        <label for="roll-initial-weight">Peso</label>
        <input
          type="number"
          id="roll-initial-weight"
          formControlName="initial_weight_kg"
          class="basic-input"
        />
      </div>

      <div class="flex flex-col gap-2">
        <label for="roll-width">Ancho</label>
        <input
          type="number"
          id="roll-width"
          formControlName="width"
          class="basic-input"
        />
      </div>
    </div>

    <div class="flex flex-row gap-x-2">
      <div class="flex flex-col gap-2 flex-1/3">
        <label for="roll-units">Número de Unidades</label>
        <input
          type="number"
          id="roll-units"
          class="basic-input"
          value="1"
          disabled
        />
      </div>

      <div class="flex flex-col gap-2 flex-1/3">
        <label for="roll-purchase-cost">Costo de Compra</label>
        <input
          type="number"
          id="roll-purchase-cost"
          formControlName="purchase_cost"
          class="basic-input"
        />
      </div>

      <div class="flex flex-col gap-2 flex-1/3">
        <label for="roll-purchase-cost-uom">Unidad de Medida</label>
        <ng-select
          id="roll-purchase-cost-uom"
          [items]="uoms"
          bindLabel="name"
          bindValue="id"
          [multiple]="false"
          [searchable]="false"
          [clearable]="false"
          [closeOnSelect]="true"
          formControlName="purchase_cost_uom"
        >
        </ng-select>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <label for="roll-purchase-reference">Referencia de Compra</label>
      <input
        type="text"
        id="roll-purchase-reference"
        formControlName="purchase_reference"
        class="basic-input"
      />
    </div>

    <!-- formControlName="units" -->

    <div
      class="flex flex-col-reverse sm:flex-row sm:justify-between sm:space-x-2"
    >
      <button type="button" class="secondary normal" (click)="cancel()">
        Cancelar
      </button>

      <button type="button" class="outlined normal" (click)="clearForm()">
        Limpiar
      </button>

      <button
        type="submit"
        [disabled]="rollForm.invalid"
        class="primary normal"
      >
        {{ buttonText }}
      </button>
    </div>

    @if (confirmationMessage) {
    <span class="mt-2 text-green-700 text-sm">{{ confirmationMessage }}</span>
    } @if (errorMessage) {
    <span class="mt-2 text-red-700 text-sm">{{ errorMessage }}</span>
    }
  </form>
</app-modal>
}
